export let meAvatarTriggerTooltipTextString = "SfUK9";
export default {meAvatarTriggerTooltipTextString};